import Vue from 'vue';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from "../const";
import {
  ADD_EXCHANGE_AGGREGATOR_USER, DELETE_EXCHANGE_AGGREGATOR_USER,
  EDIT_EXCHANGE_HANDLERS_ACCOUNTS,
  LOAD_EXCHANGES_INFO,
  RESET_EXCHANGES
} from "../const/exchanges";

export default {
  namespaced: true,
  state: {
    exchanges: [],
  },
  getters: {
    exchanges: state => state.exchanges,
  },
  actions: {
    [LOAD_EXCHANGES_INFO]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_EXCHANGES_INFO,
        namespace: 'exchanges',
      }, {root: true});
    },
    [EDIT_EXCHANGE_HANDLERS_ACCOUNTS]: async ({ dispatch }, { id, accounts }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_EXCHANGE_HANDLERS_ACCOUNTS,
        namespace: 'exchanges',
        replace: { id },
        body: { accounts },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [ADD_EXCHANGE_AGGREGATOR_USER]: async ({ dispatch }, { group, name }) => {
      const request = await dispatch(HTTP_POST, {
        method: ADD_EXCHANGE_AGGREGATOR_USER,
        namespace: 'exchanges',
        replace: { group },
        body: { name },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
    [DELETE_EXCHANGE_AGGREGATOR_USER]: async ({ dispatch }, { group, name }) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_EXCHANGE_AGGREGATOR_USER,
        namespace: 'exchanges',
        replace: { group },
        body: { name },
        no_commit: true,
      }, {root: true});
      return request ? request.data : { success: false, message: 'Неудачный запрос' };
    },
  },
  mutations: {
    [LOAD_EXCHANGES_INFO]: (state, { data }) => {
      Vue.set(state, 'exchanges', data);
    },
    [RESET_EXCHANGES]: (state) => {
      Vue.set(state, 'exchanges', []);
    },
  },
};
